<template>
	<router-view :data="product" v-if="dataReady"></router-view>
</template>
<script>
import productHTTP from '@/api/modules/product/product'
export default {
	data () {
		return {
			dataReady: false,
			id: null,
			product: {}
		}
	},
	created () {
		this.id = parseInt(this.$route.params.id)
		this.getProduct()
	},
	methods: {
		getProduct () {
			productHTTP.getProductById(this.id).then((product) => {
				this.product = product
				this.setTitle()
				this.setBreadcrumb()
				this.dataReady = true
			}, (response) => {
				this.dataReady = true
			})
		},
		setTitle () {
			document.title = this.product.title
		},
		setBreadcrumb () {
			const breadcrumb = document.querySelector('.breadcrumb')
			const items = breadcrumb.getElementsByTagName('li')

			if (items.length > 0) {
				const li = document.createElement('li')
				li.className = items[0].className
				li.innerText = this.product.title
				breadcrumb.appendChild(li)
			}
		},
		removeBreadcrumb () {
			const breadcrumb = document.querySelector('.breadcrumb')
			const listItems = breadcrumb.getElementsByTagName('li')
			const last = listItems[listItems.length - 1]
			last.parentNode.removeChild(last)
		}
	},
	beforeDestroy () {
		this.removeBreadcrumb()
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/product/viewTabs/layout.vue